module.exports = __webpack_public_path__ + "img/aboutUs6_en2024.9e32ddb.png";